import {
  Entity,
  type EntityFields,
  type EntityRecord,
  Fields,
} from '@burnsred/entity';
import { default as DjangoRestFramework } from '@burnsred/entity-duck-namespace-drf';

import { duckAppName } from '@/constants';

import ApplicationRefEntity, {
  type ApplicationRefEntityRecord,
} from './ApplicationRef';
import type { DateTimeValue } from './dates';
import { FilerImageEntity, type FilerImageEntityRecord } from './Filer';
import type { ScanStatus } from './scan';

class ApplicationImageEntity extends Entity {
  static paginated = false;

  static paths = {
    apiBase: '/applications/v1/application_image/',
  };

  static fields: EntityFields<ApplicationImageEntityFields> = {
    uuid: new Fields.IdField(),
    application: new Fields.EntityField({ entity: ApplicationRefEntity }),
    image: new Fields.EntityField({ entity: FilerImageEntity }),
    sort_order: new Fields.IntegerField({ default: 0 }),
    scan_status: new Fields.CharField({ blank: true, local: true }),
    created: new Fields.DateTimeField({ blank: true, local: true }),
    modified: new Fields.DateTimeField({ blank: true, local: true }),
  };

  static dataToRecord(data: Partial<ApplicationImageData>) {
    return super.dataToRecord(data) as ApplicationImageEntityRecord;
  }
}

export type ApplicationImageEntityFields = {
  uuid: string;
  application: ApplicationRefEntityRecord | null;
  image: FilerImageEntityRecord | null;
  sort_order: number;
  scan_status: string;
  created: DateTimeValue;
  modified: DateTimeValue;
};

export type ApplicationImageEntityRecord =
  EntityRecord<ApplicationImageEntityFields>;

export type ApplicationImageData = {
  uuid: string;
  application?: { uuid: string; name: string; slug: string };
  image: {
    id: number | string;
    name: string;
    url: string;
    thumbnails?: Record<string, string>;
    scan_status?: ScanStatus;
  };
  sort_order: number;
  scan_status?: ScanStatus;
  created: string;
  modified: string;
};

ApplicationImageEntity.duck = new DjangoRestFramework({
  app: duckAppName,
  entity: ApplicationImageEntity,
  name: 'ApplicationImageEntity',
});

export default ApplicationImageEntity;
